import AnalyticsAudienceReportingWrapper from './Wrapper'

export default AnalyticsAudienceReportingWrapper
